import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { Autocomplete } from '@material-ui/lab'
import React, { useContext, useEffect, useState } from 'react'
import Context from '../../../context'
import { getPartnerById, getPartnersList, getUnityById } from '../../../services/ClubeApi'
import { updateUserPartnerAndUnity } from '../../../services/auth'

function ValidateSelectUnit() {
  const { openModal, setOpenModal, user, setUnityId, setUnityData } = useContext(Context)

  const [partnerList, setPartnerList] = useState([])
  const [fullUnitiesList, setFullUnitiesList] = useState([])
  const [showPartnerSelect, setShowPartnerSelect] = useState(false)
  const [partnerId, setPartnerId] = useState(null)
  const [disableUnitySelect, setDisableUnitySelect] = useState(true)
  const [selectedPartner, setSelectedPartner] = useState('')
  const loading = openModal && partnerList.length === 0

  const updateList = async () => {
    return getPartnersList()
  }

  useEffect(() => {
    if (user && (user.userGroup === 1 || user.userGroup === 4 || user.userGroup === 5)) {
      setShowPartnerSelect(true)
      setDisableUnitySelect(true)
      setFullUnitiesList([])
      updateList().then(r => {
        setPartnerList(r)
        setDisableUnitySelect(false)
      })
    }

    if (user && user.userGroup === 4) {
      setShowPartnerSelect(false)
    }

    if (user && user.partnerId) {
      console.log('user.partnerId', user.partnerId)
      setDisableUnitySelect(true)
      getPartnerById(user.partnerId).then(r => {
        if (r) {
          const { partnerUnits } = r
          setFullUnitiesList([...partnerUnits])
          setDisableUnitySelect(false)
        }
      })
    }

    if (user && !user.partnerId) {
      setShowPartnerSelect(true)
      getPartnersList().then(r => {
        setPartnerList(Array.from(r).filter(item => item.PartnerUnits.length > 0))
      })
    }
  }, [user])

  useEffect(() => {
    const partner = partnerList.find(item => item.fantasyName === selectedPartner)

    if (partner && partner.id) {
      const { id } = partner
      setDisableUnitySelect(true)
      setPartnerId(id)
      getPartnerById(id).then(r => {
        if (r) {
          const { partnerUnits } = r
          setFullUnitiesList([...partnerUnits])
          setDisableUnitySelect(false)
        }
      })
    }
  }, [selectedPartner])

  const handleSelect = value => {
    setUnityId(value)
    partnerId && updateUserPartnerAndUnity(partnerId, value)
    getUnityById(value).then(r => {
      setUnityData(r)
      setOpenModal(false)
    })
  }

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={openModal}
      onClose={() => {
        setOpenModal(false)
      }}
    >
      <DialogContent>
        <div className="modal-content" style={{ padding: '10px', minWidth: '200px' }}>
          {showPartnerSelect && (
            <div style={{ marginBottom: '15px' }}>
              <Autocomplete
                id="partner"
                onInputChange={e => setSelectedPartner(e.target.innerHTML)}
                options={partnerList}
                getOptionLabel={option => option.fantasyName}
                style={{ width: '100%' }}
                loading={loading}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Selecione um Parceiro"
                    value={selectedPartner}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </>
                      )
                    }}
                  />
                )}
              />
            </div>
          )}

          <FormControl variant="outlined">
            <InputLabel id="unit-label">Selecione um Local</InputLabel>
            <Select
              disable={fullUnitiesList.length < 1}
              labelId="unit-label"
              id="unit"
              onChange={e => handleSelect(e.target.value)}
            >
              <MenuItem value="">
                <em>Selecione</em>
              </MenuItem>
              {fullUnitiesList.map(item => (
                <MenuItem key={item.id} value={item.id}>
                  {item.fantasyName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ValidateSelectUnit
